import {
  ColumnBreak,
  ISectionOptions,
  Paragraph,
  SectionType,
  TextRun,
} from 'docx'
import { createHyperlink, formatLocation } from './common'
import { Resume } from '@/types/resume/v1'

const getContact = (basics: Resume.Basics): Paragraph[] => {
  const children: Paragraph[] = []

  if (basics.email) {
    children.push(
      new Paragraph({
        children: [createHyperlink(basics.email, `mailto:${basics.email}`)],
        style: 'basicsContact',
      })
    )
  }

  if (basics.url) {
    children.push(
      new Paragraph({
        children: [createHyperlink(basics.url, basics.url)],
        style: 'basicsContact',
      })
    )
  }

  children.push(
    ...(basics.profiles || [])
      .filter(profile => profile.url)
      .map(
        profile =>
          new Paragraph({
            children: [createHyperlink(profile.url, profile.url)],
            style: 'basicsContact',
          })
      )
  )

  if (basics.phone) {
    children.push(new Paragraph({ text: basics.phone, style: 'basicsContact' }))
  }

  if (basics.location) {
    children.push(
      new Paragraph({
        children: [new TextRun({ text: formatLocation(basics.location) })],
        style: 'basicsContact',
      })
    )
  }

  return children
}

export default (basics: Resume.Basics): ISectionOptions[] => {
  const header: ISectionOptions = {
    properties: {
      type: SectionType.CONTINUOUS,
      column: {
        count: 2,
      },
    },
    children: [
      new Paragraph({
        text: basics.name,
        style: 'basicsName',
      }),
      new Paragraph({
        text: basics.label,
        style: 'basicsLabel',
      }),
      new Paragraph({
        children: [new ColumnBreak()],
      }),
      ...getContact(basics),
    ],
  }

  const summary: ISectionOptions = {
    properties: {
      type: SectionType.CONTINUOUS,
    },
    children: [
      new Paragraph({
        text: '\n',
      }),
      new Paragraph({
        text: basics.summary,
      }),
    ],
  }

  return [header, summary]
}
